module.exports = __webpack_public_path__ + "img/icon_ai_proposal.d3c75bc8.png";